/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import withIntegrationCardContext from 'hoc/withIntegrationCardContext';
import Slider from 'react-slick';

const GoogleTagManager = ({ sliderSettings }) => {
  const { img1, img2, img3 } = useStaticQuery(graphql`
    query {
      img1: file(relativePath: { eq: "help/gtm/gtm_3.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      img2: file(relativePath: { eq: "help/gtm/gtm_4.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      img3: file(relativePath: { eq: "help/gtm/gtm_5.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  const photos = [
    {
      img: img1.childImageSharp.fluid,
      alt: 'Google Tag Manager Integration',
      title: 'Integrate Google Tag Manager with LiveSession',
    },
    {
      img: img2.childImageSharp.fluid,
      alt: 'Google Tag Manager Integration',
      title: 'Integrate Google Tag Manager with LiveSession',
    },
    {
      img: img3.childImageSharp.fluid,
      alt: 'Google Tag Manager Integration',
      title: 'Integrate Google Tag Manager with LiveSession',
    },
  ];
  return (
    <>
      <Slider {...sliderSettings(photos)}>
        {photos.map(({ img, alt, title }) => (
          <div>
            <Img fluid={img} alt={alt} title={title} />
          </div>
        ))}
      </Slider>
      <div className="section">
        <h2>Overview</h2>
        <p>
          Google Tag Manager is a comprehensive tool to manage marketing tags, such as tracking
          pixels or code snippets. Now you can connect it with LiveSession and get even more
          insights on user behavior.
        </p>
      </div>
      <div className="section">
        <h2>Benefits</h2>
        <ul className="checkmarks">
          <li>Install the integration without using code, just add a custom tag</li>
          <li>Access qualitative and quantitative data in one place</li>
          <li>Get in-depth insights and make more data-driven decisions</li>
        </ul>
      </div>
      <h2>How to install</h2>
      <p>
        Just add a tag in Google Tag Manager, as described in our{' '}
        <a href="/help/how-install-with-google-tag-manager/">help center</a>.
      </p>
    </>
  );
};

export default withIntegrationCardContext(GoogleTagManager);

GoogleTagManager.propTypes = {
  sliderSettings: PropTypes.func.isRequired,
};
